import { object, string, number } from "yup";

export const initialValues = (props) => ({
  description: props.description || "",
});

export const validationSchema = object({
  description: string()
    .trim()
    .max(500, "Must be 500 characters or less")
    .required("Required"),
});

export const backtestFilterInitialValues = {
  start: "",
  end: "",
  quickSelect: "",
  fees: "0",
  initialBalance: "100000",
  slippage: "0",
};

export const backtestFilterValidationSchema = object({
  start: string().trim().required("Start date is required"),
  end: string().trim().required("End date is required"),
  quickSelect: string().trim(),
  fees: number().typeError("Invalid number"),
  initialBalance: number().typeError("Invalid number"),
  slippage: number().typeError("Invalid number"),
});
